/*
 * True Relevance mark, copied verbatim from the design system's assets/logo/tr-mark-white.svg.
 *
 * The artwork is not redrawn or altered — only the fill is bound to `currentColor`, which is the
 * one variation the brand allows (ink ↔ white). It renders white here because it sits on the ink
 * sidebar.
 */
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
    color: '#FFFFFF',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 945 945"
      fill="currentColor"
      role="img"
      aria-label="True Relevance"
    >
      <g transform="matrix(0.0553563,0,0,0.0553584,31.4746,138.519)">
        <path d="M4516,7265L4526,7269L4526,7271L4532,7271L7864,8564L11197,7271L11203,7271L11203,7269L11213,7265L15736,9019L7864,12072L-8,9019L4516,7265ZM4526,3752L4526,7261L4516,7265L-8,5511L4526,3752ZM11203,3752L15736,5511L11213,7265L11203,7261L11203,3752Z" />
      </g>
      <g transform="matrix(0.0553563,0,0,0.0553584,31.4746,138.519)">
        <path d="M4536,1224L7872,-8L11208,1224L7872,2456L4536,1224Z" />
      </g>
    </svg>
  );
};
